import {
  Home,
  Person,
  People,
  Inventory2,
  RequestQuote,
  AttachMoney,
  AccountBalance,
  Payments,
  CreditCard,
  Category,
  AccountBalanceWalletOutlined,
  BusinessCenter,
  ShoppingCart,
  BrandingWatermark,
  PrecisionManufacturing,
  ViewInAr,
  Straighten,
  MonetizationOn,
  ReceiptLong,
  GroupAdd,
  Engineering,
  Paid,
  Receipt, HomeOutlined,
  Iron,
  Create,
  MoneySharp,
  Sell,
  CategoryRounded,
  LocalShipping,
  SwapVert,

} from '@mui/icons-material';

import { SvgIconComponent } from '@mui/icons-material';
import * as path from '../routes/RoutesNames';

export type Menu = {
  id: number;
  screenName: string;
  screenRoute: string;
  /**
   * [22/10] A chave da tela no catálogo de permissões (ACESSO_TELA.tela_chave).
   *
   * EXPLÍCITA, e não deduzida da rota, porque ONZE entradas deste arquivo usam texto
   * literal em screenRoute ('Produto', 'Marca', 'CategoriaFinanceira'...) em vez da
   * constante de RoutesNames. Deduzir a tela pela rota funcionava para umas e falhava
   * calado para outras - e o item falho ficava SEMPRE visível, que foi o defeito
   * relatado: tirar todas as permissões do papel e Cadastros, Produtos e Ordem Serviço
   * continuarem no menu.
   *
   * Grupo (Cadastros, Financeiro...) NÃO tem chave: ele aparece quando sobra pelo menos
   * um filho.
   */
  telaChave?: string;
  subscreenRoute?: string;
  icon: SvgIconComponent;
  active: boolean;
  subMenu?: any[]
};
let idCount = 0
const id = () => {
  return idCount++
}
// @ts-ignore - .
export const menus: readonly Menu[] = [
  {
    id: id(),
    screenName: 'Home',
        telaChave: 'home',
    screenRoute: path.Home,
    icon: Home,
    active: true,
  },
  {
    id: id(),
    screenName: 'Cadastros',
    screenRoute: 'Cadastros',
    icon: Create,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Banco',
        telaChave: 'banco',
        screenRoute: path.Banco,
        subscreenRoute: path.BancoCadastrar,
        icon: AccountBalance,
        active: true,
      },
      {
        id: id(),
        screenName: 'Categoria Financeira',
        telaChave: 'categoria_financeira',
        screenRoute: 'CategoriaFinanceira',
        icon: Category,
        active: true,
      },
      {
        id: id(),
        screenName: 'Centro de Custo',
        telaChave: 'centro_custo',
        screenRoute: 'CentroCusto',
        icon: BusinessCenter,
        active: true,
      },
      {
        id: id(),
        screenName: 'CFOP',
        telaChave: 'cfop',
        screenRoute: path.Cfop,
        icon: Receipt,
        active: true,
      },
      {
        id: id(),
        screenName: 'Clientes',
        telaChave: 'cliente',
        screenRoute: path.Cliente,
        subscreenRoute: path.ClienteAtualizar,
        icon: People,
        active: true,
      },
      {
        id: id(),
        screenName: 'Condição de Pagamento',
        telaChave: 'condicao_pagamento',
        screenRoute: 'CondicaoPagamento',
        icon: Payments,
        active: true,
      },
      {
        id: id(),
        screenName: 'Conta Bancária',
        telaChave: 'conta_bancaria',
        screenRoute: 'ContaBancaria',
        icon: AccountBalanceWalletOutlined,
        active: true,
      },
      {
        id: id(),
        screenName: 'Fabricante',
        telaChave: 'fabricante',
        screenRoute: 'Fabricante',
        icon: PrecisionManufacturing,
        active: true,
      },
      {
        id: id(),
        screenName: 'Forma de Pagamento',
        telaChave: 'forma_pagamento',
        screenRoute: 'FormaPagamento',
        icon: MonetizationOn,
        active: true,
      },
      {
        id: id(),
        screenName: 'Grupo de Clientes',
        telaChave: 'grupo_cliente',
        screenRoute: path.GrupoCliente,
        icon: GroupAdd,
        active: true,
      },
      {
        id: id(),
        screenName: 'Grupo de Produtos',
        telaChave: 'grupo_produto',
        screenRoute: 'GrupoProduto',
        icon: ShoppingCart,
        active: true,
      },
      {
        id: id(),
        screenName: 'Tipo de Pagamento',
        telaChave: 'tipo_pagamento',
        screenRoute: 'TipoPagamento',
        icon: CreditCard,
        active: true,
      },
      {
        id: id(),
        screenName: 'Unidade de Medida',
        telaChave: 'unidade_medida',
        screenRoute: 'UnidadeMedida',
        icon: Straighten,
        active: true,
      },
      {
        id: id(),
        screenName: 'Usuários',
        telaChave: 'usuario',
        screenRoute: path.Usuario,
        subscreenRoute: path.UsuarioAtualizar,
        icon: Person,
        active: true,
      },
      {
        // [22/10] Papéis de acesso. Entra no catálogo de permissões sob a chave
        // 'usuario' - quem administra pessoas administra o que elas veem, e separar
        // as duas permissões só criaria o estado em que alguém cria usuário e não
        // consegue dar papel a ele.
        id: id(),
        screenName: 'Papéis de Acesso',
        telaChave: 'usuario',
        screenRoute: path.Papel,
        subscreenRoute: path.PapelAtualizar,
        icon: GroupAdd,
        active: true,

      }
    ]
  },
  {
    id: id(),
    screenName: 'Compras',
    screenRoute: 'Compras',
    icon: HomeOutlined,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Importação XML/TXT',
        telaChave: 'importacao_xml',
        screenRoute: path.ImportacaoXML,
        active: true,
      },
      {
        id: id(),
        screenName: 'Devolução ao Fornecedor',
        telaChave: 'devolucao_fornecedor',
        screenRoute: path.DevolucaoFornecedor,
        active: true,
      }
    ]
  },
  {
    id: id(),
    screenName: 'Financeiro',
    screenRoute: 'Financeiro',
    icon: MoneySharp,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Boletos',
        telaChave: 'boleto',
        screenRoute: path.Boleto,
        icon: Engineering,
        active: true,
      },
      {
        id: id(),
        screenName: 'Contas a Pagar',
        telaChave: 'contas_pagar',
        screenRoute: path.ContasPagar,
        icon: Paid,
        active: true,
      },
      {
        id: id(),
        screenName: 'Caixa Lançamento',
        telaChave: 'caixa_lancamento',
        screenRoute: path.CaixaLancamento,
        icon: Paid,
        active: true
      },
      {
        id: id(),
        screenName: 'Contas a Receber',
        telaChave: 'contas_receber',
        screenRoute: path.ContasReceber,
        icon: AttachMoney,
        active: true,
      },

      {
        id: id(),
        screenName: 'Prestação de Contas',
        telaChave: 'prestacao_contas',
        screenRoute: path.PrestacaoDeContas,
        subscreenRoute: path.PrestacaoDeContasCadastro,
        icon: RequestQuote,
        active: true,
      },
      {
        id: id(),
        screenName: 'Nota Fiscal',
        telaChave: 'nota_fiscal',
        screenRoute: path.NotaFiscal,
        // subscreenRoute: path.NotaFiscal,
        icon: RequestQuote,
        active: true,
      }
    ]
  },
  {
    id: id(),
    screenName: 'Logistica',
    screenRoute: 'Logistica',
    icon: LocalShipping,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Movimentação de Estoque',
        telaChave: 'movimentacao_estoque',
        screenRoute: path.MovimentacaoEstoque,
        icon: SwapVert,
        active: true,
      },
      {
        id: id(),
        screenName: 'Reajuste de Estoque',
        telaChave: 'reajuste_estoque',
        screenRoute: path.ReajusteEstoque,
        icon: SwapVert,
        active: true,
      },
    ]
  },
  {
    id: id(),
    screenName: 'Produtos',
    screenRoute: 'Produtos',
    icon: CategoryRounded,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Produto',
        telaChave: 'produto',
        screenRoute: 'Produto',
        icon: Inventory2,
        active: true,
      },
    ]
  },
  {
    id: id(),
    screenName: 'Ordem Serviço',
    screenRoute: 'OrdemServico',
    icon: Sell,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Ordem de Serviço',
        telaChave: 'ordem_servico',
        screenRoute: path.OrdemServico,
        icon: Engineering,
        active: true,
      },
      {
        id: id(),
        screenName: 'Maquina',
        telaChave: 'maquina',
        screenRoute: path.Maquina,
        icon: Iron,
        active: true,
      },
      {
        id: id(),
        screenName: 'Marca',
        telaChave: 'marca',
        screenRoute: 'Marca',
        icon: BrandingWatermark,
        active: true,
      },
      {
        id: id(),
        screenName: 'Modelo',
        telaChave: 'modelo',
        screenRoute: 'Modelo',
        icon: ViewInAr,
        active: true,
      }
    ]
  },
  {
    id: id(),
    screenName: 'Vendas',
    screenRoute: 'Vendas',
    icon: AttachMoney,
    active: true,
    subMenu: [
      {
        id: id(),
        screenName: 'Pedido de Venda',
        telaChave: 'pedido',
        screenRoute: path.Pedido,
        icon: ReceiptLong,
        active: true,
      },

    ]
  }
  // {
  //   id: id(),
  //   screenName: 'Logout',
  //   screenRoute: 'Logout',
  //   icon: Logout,
  //   active: true,
  // }
] as const;
